import { Icon as ChakraIcon, IconProps as ChakraIconProps } from '@chakra-ui/react';

export interface IconProps extends ChakraIconProps {
  title?: string;
  ref?: React.RefObject<SVGSVGElement | null>;
}

export function Icon({ ref, ...props }: IconProps) {
  return <ChakraIcon ref={ref} {...props} />;
}
